import * as React from "react";
import type { SVGProps } from "react";
const SvgSkiBoots = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#ski-boots_svg__a)">
      <path d="M20 22H4c-1.1 0-2-.9-2-2V3c0-.55.45-1 1-1h7c.55 0 1 .45 1 1v5.34c0 .86.37 1.66 1.01 2.2 2.78 2.37 5.86 2.3 5.89 2.3.09 0 .18 0 .27.03 2.26.54 3.84 2.54 3.84 4.86V20c0 1.1-.9 2-2 2zM4 4v16h16v-2.27c0-1.36-.9-2.53-2.19-2.89-.77 0-4.05-.18-7.1-2.77A4.86 4.86 0 0 1 9 8.34V4z" />
      <path d="M14 17a1.01 1.01 0 0 1-.9-1.45l1-2c.25-.49.85-.69 1.34-.45.49.25.69.85.45 1.34l-1 2c-.18.35-.53.55-.9.55zM8 22c-.55 0-1-.45-1-1v-1c0-1.65-1.35-3-3-3H3c-.55 0-1-.45-1-1s.45-1 1-1h1c2.76 0 5 2.24 5 5v1c0 .55-.45 1-1 1M10 16a1.01 1.01 0 0 1-.9-1.45l1.5-3c.25-.5.85-.69 1.34-.45.49.25.69.85.45 1.34l-1.5 3c-.18.35-.53.55-.9.55zM7 12c-.42 0-.81-.26-.95-.68a1 1 0 0 1 .63-1.26l3-1a.99.99 0 0 1 1.26.63 1 1 0 0 1-.63 1.26l-3 1c-.11.04-.21.05-.32.05zM10 8H7c-.55 0-1-.45-1-1s.45-1 1-1h3c.55 0 1 .45 1 1s-.45 1-1 1" />
    </g>
    <defs>
      <clipPath id="ski-boots_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSkiBoots;
